/**
 * Outils communs aux écrans de l'organigramme (Yros/Kavero#469) : la lecture
 * de l'enveloppe des contrats C28 et C29, et le style des champs de recherche.
 */

// Le champ de recherche aux couleurs de l'application, comme le formulaire
// employé (EmployeeForm.js, `customSelectStyles`).
export const stylesRecherche = {
  control: (base, etat) => ({
    ...base,
    borderColor: etat.isFocused ? 'var(--color-primary)' : base.borderColor,
    boxShadow: etat.isFocused ? '0 0 0 1px var(--color-primary)' : base.boxShadow,
    '&:hover': { borderColor: etat.isFocused ? 'var(--color-primary)' : base.borderColor },
    borderRadius: '0.375rem',
  }),
  option: (base, etat) => ({
    ...base,
    backgroundColor: etat.isSelected
      ? 'var(--color-primary)'
      : etat.isFocused ? 'rgba(var(--color-primary-rgb), 0.1)' : base.backgroundColor,
    color: etat.isSelected ? 'white' : base.color,
  }),
};

// `enveloppeDe` vit désormais dans `components/Utils` (partagé par plusieurs
// écrans) ; il reste exporté d'ici pour les écrans qui l'importent encore.
export { enveloppeDe } from '../../components/Utils/enveloppeDe';

// Les boutons aux couleurs de l'application (jamais le violet de `btn-primary`).
export const BOUTON_PRINCIPAL = 'flex items-center gap-2 px-4 py-2 text-sm bg-[--color-primary] text-white rounded-lg hover:bg-[--bg-hover] disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200';
export const BOUTON_SECONDAIRE = 'px-3 py-2 text-sm rounded-lg text-[--color-primary] hover:bg-gray-100 disabled:opacity-50 transition-colors duration-200';
